import React, { Suspense } from "react";
import { BrowserRouter, Switch, Route } from "react-router-dom";
import { Redirect } from "react-router";
import Spinner from "react-spinkit";

import { colors } from "../Css";

import LoginPage from "../containers/Auth/Login";
import RegisterPage from "../containers/Auth/Register";
import Canvas from "../containers/Canvas";
import { Recordings } from "../Replayer";
import NewCanvas from "../NewCanvas";
import NewCanvas2 from "../NewCanvas2";
import PasswordRecoveryPage from "../containers/Auth/ForgotPassword";
import ResetPassword from "../containers/Auth/ResetPassword";
import CoursePage from "../containers/CoursePage";
import Dashboard from "../containers/Dashboard";

export const PublicPaths = {
  LOGIN: "/login",
  SIGNUP: "/signup",
  INVITATION: "/signup/invite/:inviteId",
  SCHOOL_SETUP: "/school/setup",
  SCHOOL_LANDING: "/school",
  FORGOT_PASSWORD: "/forgot-password",
  PASSWORD_RECOVERY_MESSAGE: "/password-recovery-message",
  RESET_PASSWORD: "/reset-password",
};

export const PrivatePaths = {
  DASHBOARD: "/dashboard",
};

const Routes = () => {
  const renderFallbackUI = () => {
    return (
      <div
        style={{
          width: "100%",
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Spinner name="double-bounce" color={colors.primary} />
      </div>
    );
  };

  return (
    <Suspense fallback={renderFallbackUI()}>
      <BrowserRouter>
        <Switch>
          <Route exact path="/" render={() => <Redirect to="/login" />} />
          <Route exact path="/login" component={LoginPage} />
          <Route exact path="/signup" component={RegisterPage} />
          <Route
            exact
            path="/forgot-password"
            component={PasswordRecoveryPage}
          />
          <Route exact path="/password-reset" component={ResetPassword} />
          {/* <Route exact path="/signup/invites/:id" component={AdminSignup} /> */}
          <Route path="/dashboard" component={Dashboard} />
          <Route exact path="/course" component={CoursePage} />
          <Route exact path="/canvas" component={Canvas} />
          <Route exact path="/new" component={NewCanvas} />
          <Route exact path="/canvas-two" component={NewCanvas2} />
          <Route exact path="/recordings" component={Recordings} />
        </Switch>
      </BrowserRouter>
    </Suspense>
  );
};

export default Routes;
